export const chargeListRegistrationSlip = {
    panels: [
        {
            index: 0,
            height: 200,
            width: 100,
            paperHeader: 543,
            paperFooter: 566.9291338582677,
            printElements: [
                {
                    options: {
                        left: 99,
                        top: 6,
                        height: 25.5,
                        width: 81,
                        title: "九阵科技",
                        fontSize: 19.5,
                        fontWeight: "600",
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 42,
                        top: 34.5,
                        height: 48,
                        width: 198,
                        field: "oneDimensionalCode"
                    },
                    printElementType: {
                        type: "image"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 94.5,
                        height: 21,
                        width: 75,
                        field: "name",
                        fontSize: 12.75,
                        fontWeight: "900",
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 130.5,
                        top: 94.5,
                        height: 21,
                        width: 43.5,
                        field: "age",
                        fontSize: 12.75,
                        fontWeight: "900",
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 186,
                        top: 94.5,
                        height: 21,
                        width: 90,
                        field: "patId",
                        fontSize: 12.75,
                        fontWeight: "900",
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 90,
                        top: 94.5,
                        height: 21,
                        width: 33,
                        field: "sex",
                        fontSize: 12.75,
                        fontWeight: "900",
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 129,
                        height: 19.5,
                        width: 130.5,
                        title: "现金支付",
                        field: "cashAmt",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 156,
                        height: 21,
                        width: 130.5,
                        title: "合计金额",
                        field: "receAmt",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 186,
                        height: 21,
                        width: 129,
                        title: "治疗费",
                        field: "disposeCost",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 217.5,
                        height: 22.5,
                        width: 129,
                        title: "西药费",
                        field: "westCost",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 316.5,
                        height: 21,
                        width: 267,
                        title: "打印时间",
                        field: "printTime",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 10.5,
                        top: 285,
                        height: 19.5,
                        width: 127.5,
                        title: "收费员",
                        field: "chargeUser",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 9,
                        top: 348,
                        height: 36,
                        width: 261,
                        title: "此收费单作为接受医疗服务的重要依据,请妥善保管!",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle",
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 6,
                        top: 399,
                        height: 9,
                        width: 267,
                        borderWidth: "0.75"
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 10.5,
                        top: 412.5,
                        height: 22.5,
                        width: 129,
                        title: "票据代码:",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 10.5,
                        top: 453,
                        height: 21,
                        width: 127.5,
                        title: "票据号:",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 490.5,
                        height: 25.5,
                        width: 127.5,
                        title: "验证码:",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 10.5,
                        top: 250.5,
                        height: 22.5,
                        width: 127.5,
                        title: "挂号费",
                        field: "registrationCost",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                }
            ],
            paperNumberLeft: 253,
            paperNumberTop: 544,
            paperNumberDisabled: true
        }
    ]
}